import { render } from "./requestInfo.vue?vue&type=template&id=4755270c&scoped=true"
import script from "./requestInfo.vue?vue&type=script&lang=js"
export * from "./requestInfo.vue?vue&type=script&lang=js"

import "./requestInfo.vue?vue&type=style&index=0&id=4755270c&lang=scss&scoped=true"
import "./requestInfo.vue?vue&type=style&index=1&id=4755270c&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4755270c"]])

export default __exports__